import { c as _c } from "react/compiler-runtime";
import { CardLayout } from "@components/progress-overview/card-layout";
import { getProjectByIdSelector } from "@store/projects/projects-selector";
import { useAppDispatch, useAppSelector } from "@store/store-helper";
import { removeOne } from "@store/upload-tasks/upload-tasks-slice";
import { FontWeights, Text } from "@flat-ui";
import { withEllipsis } from "@styles/common-styles";
import { useMemo } from "react";
/**
 * Renders dismissible card showing an error and the cause, if available
 */
export function ErrorCard(t0) {
  const $ = _c(15);
  const {
    task
  } = t0;
  let t1;
  if ($[0] !== task.context.projectId) {
    t1 = getProjectByIdSelector(task.context.projectId);
    $[0] = task.context.projectId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const project = useAppSelector(t1);
  const dispatch = useAppDispatch();
  const errorMessage = task.errorMessage ?? "Unexpected error. Please contact support.";
  let t2;
  if ($[2] !== dispatch || $[3] !== task.id) {
    t2 = async function dismissErrorTask() {
      dispatch(removeOne(task.id));
    };
    $[2] = dispatch;
    $[3] = task.id;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const dismissErrorTask = t2;
  const t3 = project?.name;
  let t4;
  if ($[5] !== dismissErrorTask) {
    t4 = [{
      name: "Clear",
      callback: dismissErrorTask
    }];
    $[5] = dismissErrorTask;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      color: "error.main",
      fontWeight: FontWeights.SemiBold,
      ...withEllipsis
    };
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== errorMessage) {
    t6 = <Text variant="bodyS" sx={t5}>{errorMessage}</Text>;
    $[8] = errorMessage;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t3 || $[11] !== t4 || $[12] !== t6 || $[13] !== task.fileName) {
    t7 = <CardLayout name={task.fileName} projectName={t3} menu={t4}>{t6}</CardLayout>;
    $[10] = t3;
    $[11] = t4;
    $[12] = t6;
    $[13] = task.fileName;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
}